import { GraphicAccent } from './GraphicAccent';
export default GraphicAccent;
